import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { parse } from 'query-string';
import { useDispatch } from 'react-redux';

import { RegistrationRedirectError } from '../../components/registration/registration.interface';
import { initSignup } from './signupSlice';
import { setRedirectError } from '../redirectError/redirectErrorSlice';
import { signupFromQuery } from './helper';
import { getApplication } from '../hmi/hmiSlice';

type Props = {
  children: React.ReactNode;
};

type Query = {
  redirect_uri?: string;
  application_id?: string;
  tags?: string;
  lang?: string;
};

export const SignupParamsHandler: React.FC<Props> = (props) => {
  const location = useLocation();
  const { redirect_uri: redirectUri, application_id: applicationId, tags, lang } = parse(location.search) as Query;
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const signup = signupFromQuery(applicationId, redirectUri, tags);
      dispatch(initSignup(signup));
      dispatch(getApplication(signup.applicationId, lang || 'en'));
    } catch (err) {
      const error: RegistrationRedirectError = {
        error: 'application_misconfigured',
        reason: err.message,
      };
      dispatch(setRedirectError(error));
    }
    // eslint-disable-next-line
  }, []);

  return <>{props.children}</>;
};
